/**
 * Content Grid JS
 * -----------------------------------------------------------------------------
 *
 * All the JS for the Content Grid component.
 */

( function( app ) {
  const COMPONENT = {

    className: 'announcement-banner',

    selector: function() {
      return '.' + this.className;
    },

    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      window.debounce = require( 'lodash/debounce' );

      /**
       * Sets the CSS variable for the announcement banner height
       */
      function setAnnouncementBannerHeight() {
        if ( $( '#announcement-banner:visible' ).length ) {
          const bannerHeight = $( '#announcement-banner' ).outerHeight();
          $( ':root' ).css( '--announcementBannerHeight', `${bannerHeight}px` );
        } else {
          // Always provide a safe fallback
          $( ':root' ).css( '--announcementBannerHeight', '0px' );
        }
      }

      /**
       * Closes the announcement banner
       */
      function closeAnnouncementBanner() {
        $( '#announcement-banner' ).slideUp( 0, function() {
          setAnnouncementBannerHeight();
        } );
      }

      /**
       * Opens the announcement banner
       */
      function openAnnouncementBanner() {
        $( '#announcement-banner' ).slideDown( 0, function() {
          setAnnouncementBannerHeight();
        } );
      }

      // Initial height calculation
      setAnnouncementBannerHeight();

      // Recalculate on resize
      $( window ).on(
          'resize',
          debounce( function() {
            setAnnouncementBannerHeight();
          }, 100 ),
      );

      // Initialize session storage flag
      if ( ! sessionStorage.getItem( 'announcement-bannerseen' ) ) {
        sessionStorage.setItem( 'announcement-bannerseen', 'false' );
      }

      // Open banner if it has not been seen
      if ( sessionStorage.getItem( 'announcement-bannerseen' ) === 'false' ) {
        openAnnouncementBanner();
      }

      // Close button handler
      $( '#announcement-banner__close' ).on( 'click', function() {
        closeAnnouncementBanner();
        sessionStorage.setItem( 'announcement-bannerseen', 'true' );
      } );
    },

    finalize: function() {},
  };

  // Hooks the component into the app
  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
